import Config from '@config';
import { initializeGasConsumingEquipmentCommercialApi } from '@gasbi/shared/common/features/gasConsumingEquipmentCommercial';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  gasConsumingEquipmentCommercialApi,
  useGetGasConsumingEquipmentsCommercialQuery,
  useGetGasConsumingEquipmentByIdCommercialQuery,
  useCreateGasConsumingEquipmentsCommercialMutation,
  useUpdateGasConsumingEquipmentsCommercialMutation,
  useGetGasConsumingEquipmentsCommercialInfiniteQuery,
  getCachedEquipmentCommercialByIdSelector,
  useGetCachedEquipmentCommercialByIdSelector,
} = initializeGasConsumingEquipmentCommercialApi(
  Config.VITE_API_URL,
  axiosBaseQuery,
);
